var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 376.94,
    height: 49,
    viewBox: "0 0 376.94 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.498,
    y1: -0.019,
    x2: 0.502,
    y2: 1.034,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#de127f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc24bf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.496,
    y1: -0.023,
    x2: 0.5,
    y2: 1.031,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.497,
    y1: -0.033,
    x2: 0.502,
    y2: 1.027,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: -0.036,
    x2: 0.505,
    y2: 1.023,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    y1: -0.004,
    x2: 0.5,
    y2: 1.128,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242323"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DigitMart_387x81_Logo",
    transform: "translate(-5 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M201.812,62.056a2.784,2.784,0,0,1-.852,2.077,2.842,2.842,0,0,1-2.077.853,2.781,2.781,0,0,1-2.077-.853,2.842,2.842,0,0,1-.853-2.077V18.965a2.7,2.7,0,0,1,.62-1.752,3.313,3.313,0,0,1,1.6-1.1,2.925,2.925,0,0,1,1.891.124,2.976,2.976,0,0,1,1.426,1.3L218.15,47.222l16.663-29.683a2.971,2.971,0,0,1,1.426-1.3,2.735,2.735,0,0,1,1.891-.124,3.179,3.179,0,0,1,1.565,1.1,2.839,2.839,0,0,1,.589,1.752V62.056a2.784,2.784,0,0,1-.852,2.077,2.842,2.842,0,0,1-2.077.853,2.781,2.781,0,0,1-2.077-.853,2.842,2.842,0,0,1-.853-2.077V30.218L220.692,54.693a2.753,2.753,0,0,1-2.542,1.5,2.817,2.817,0,0,1-2.6-1.5L201.812,30.218V62.056Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M293.214,60.754a2.993,2.993,0,0,1,.124,2.279,2.847,2.847,0,0,1-1.069,1.426,2.976,2.976,0,0,1-1.721.527,2.808,2.808,0,0,1-2.666-1.627l-5.8-12.044H257.222l-5.859,12.044a2.874,2.874,0,0,1-1.1,1.209,3.038,3.038,0,0,1-1.566.418,2.9,2.9,0,0,1-1.689-.527,2.426,2.426,0,0,1-1.039-1.426,2.6,2.6,0,0,1,.124-2.279l20.9-43.029a2.79,2.79,0,0,1,2.666-1.69,2.959,2.959,0,0,1,1.565.449,2.617,2.617,0,0,1,1.039,1.24Zm-14-15.361-9.564-19.655L260.09,45.393h19.128Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M337.286,31.007a13.972,13.972,0,0,1-.775,4.619,14.689,14.689,0,0,1-2.186,4.03,15.313,15.313,0,0,1-3.317,3.162,14.327,14.327,0,0,1-4.2,1.984l9.053,15.748a3.11,3.11,0,0,1,.294,2.248,2.914,2.914,0,0,1-1.395,1.8,2.7,2.7,0,0,1-1.426.388,2.947,2.947,0,0,1-1.472-.388,2.708,2.708,0,0,1-1.07-1.1l-10.478-18.1h-15.5V62.054a2.784,2.784,0,0,1-.852,2.077,2.843,2.843,0,0,1-2.077.853,2.782,2.782,0,0,1-2.077-.853,2.842,2.842,0,0,1-.853-2.077V19.288a2.781,2.781,0,0,1,.853-2.077,2.841,2.841,0,0,1,2.077-.852H303.9c1.3,0,2.96,0,4.975-.031,2.015-.015,4.248-.031,6.666-.031H322.7a14.73,14.73,0,0,1,5.735,1.132,13.935,13.935,0,0,1,4.619,3.162,15.47,15.47,0,0,1,3.085,4.681,14.473,14.473,0,0,1,1.147,5.735Zm-5.859-.062a8.869,8.869,0,0,0-2.543-6.231,8.481,8.481,0,0,0-2.774-1.891,8.719,8.719,0,0,0-3.426-.682h-17.9V39.516h17.9a8.452,8.452,0,0,0,3.348-.682,8.562,8.562,0,0,0,2.775-1.86,9.328,9.328,0,0,0,1.891-2.728,7.824,7.824,0,0,0,.713-3.317Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M343.406,22.156a2.783,2.783,0,0,1-2.077-.853,2.841,2.841,0,0,1-.852-2.077,2.784,2.784,0,0,1,.852-2.077,2.842,2.842,0,0,1,2.077-.853h35.6a2.783,2.783,0,0,1,2.077.853,2.841,2.841,0,0,1,.852,2.077,2.784,2.784,0,0,1-.852,2.077,2.869,2.869,0,0,1-2.077.853h-14.85V62.07a2.784,2.784,0,0,1-.852,2.077,2.843,2.843,0,0,1-2.077.853,2.782,2.782,0,0,1-2.077-.853,2.842,2.842,0,0,1-.853-2.077l-.062-39.914H343.406Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M24.732,16.3a23.181,23.181,0,0,1,9.533,1.829,24.587,24.587,0,0,1,7.781,5.177,24.3,24.3,0,0,1,5.239,7.719,24.447,24.447,0,0,1,0,19,24.166,24.166,0,0,1-5.239,7.688,24.767,24.767,0,0,1-7.781,5.146,23.7,23.7,0,0,1-9.533,1.829H7.93a2.783,2.783,0,0,1-2.077-.853A2.842,2.842,0,0,1,5,61.762V19.244a2.783,2.783,0,0,1,.853-2.077,2.842,2.842,0,0,1,2.077-.853h16.8ZM10.859,22.159V58.817H24.732a17.64,17.64,0,0,0,7.223-1.364,19.112,19.112,0,0,0,5.921-3.906,18.248,18.248,0,0,0,4-5.828,17.767,17.767,0,0,0,1.473-7.192,17.513,17.513,0,0,0-1.473-7.192,18.558,18.558,0,0,0-9.92-9.8,17.435,17.435,0,0,0-7.223-1.364H10.859Z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M100.127,43.44a2.782,2.782,0,0,1-2.077-.853A2.842,2.842,0,0,1,97.2,40.51a2.783,2.783,0,0,1,.853-2.077,2.867,2.867,0,0,1,2.077-.853h19.081a2.782,2.782,0,0,1,2.077.853,2.842,2.842,0,0,1,.853,2.077,23.714,23.714,0,0,1-1.922,9.533,24.77,24.77,0,0,1-5.239,7.781,24.493,24.493,0,0,1-7.782,5.239,24.6,24.6,0,0,1-19.065,0,24.753,24.753,0,0,1-7.781-5.239,24.494,24.494,0,0,1-5.239-7.781,24.6,24.6,0,0,1,0-19.065,24.477,24.477,0,0,1,13.02-13.02,23.76,23.76,0,0,1,9.533-1.922A24.092,24.092,0,0,1,108.5,18.577a24.653,24.653,0,0,1,8.634,7.1,2.8,2.8,0,0,1,.589,2.155,3.076,3.076,0,0,1-.976,1.829,2.785,2.785,0,0,1-1.953.713,2.724,2.724,0,0,1-2.279-1.1,19.2,19.2,0,0,0-6.6-5.441,18.243,18.243,0,0,0-8.231-1.922,17.968,17.968,0,0,0-7.223,1.473,18.782,18.782,0,0,0-9.92,9.92,18.024,18.024,0,0,0-1.472,7.223,17.712,17.712,0,0,0,1.472,7.223,18.782,18.782,0,0,0,9.92,9.92,18.59,18.59,0,0,0,13.764.294,18.435,18.435,0,0,0,5.534-3.286,19.66,19.66,0,0,0,4.108-4.976,18.066,18.066,0,0,0,2.185-6.247H100.158Z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M151.945,22.156a2.783,2.783,0,0,1-2.077-.853,2.841,2.841,0,0,1-.852-2.077,2.784,2.784,0,0,1,.852-2.077,2.843,2.843,0,0,1,2.077-.853h35.6a2.783,2.783,0,0,1,2.077.853,2.841,2.841,0,0,1,.852,2.077,2.784,2.784,0,0,1-.852,2.077,2.869,2.869,0,0,1-2.077.853H172.7V62.07a2.784,2.784,0,0,1-.852,2.077,2.843,2.843,0,0,1-2.077.853,2.782,2.782,0,0,1-2.077-.853,2.842,2.842,0,0,1-.853-2.077l-.062-39.914H151.945Z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M64.043,61.76a2.783,2.783,0,0,1-.853,2.077,2.842,2.842,0,0,1-2.077.852,2.783,2.783,0,0,1-2.077-.852,2.842,2.842,0,0,1-.852-2.077v-42.5a2.783,2.783,0,0,1,.852-2.077,2.842,2.842,0,0,1,2.077-.853,2.782,2.782,0,0,1,2.077.853,2.842,2.842,0,0,1,.853,2.077Z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M137.25,61.916a2.781,2.781,0,0,1-.853,2.077,2.841,2.841,0,0,1-2.077.853,2.783,2.783,0,0,1-2.077-.853,2.841,2.841,0,0,1-.852-2.077v-42.5a2.784,2.784,0,0,1,.852-2.077,2.843,2.843,0,0,1,2.077-.853,2.782,2.782,0,0,1,2.077.853,2.842,2.842,0,0,1,.853,2.077Z",
    fill: "url(#linear-gradient-5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDm);
export default __webpack_public_path__ + "static/media/DM.e1c41fcec20ba0500c08961c45004f95.svg";
export { ForwardRef as ReactComponent };